import { patchRequest } from '@/core';
import { savedOrderSearches } from '@/requests';

export default async function updateMultipleSavedOrderSearchesRequest(patch) {
	let url = savedOrderSearches.getPath();
	let response = await patchRequest(url, {}, patch);
	return response;
}
